export default "__VITE_ASSET__BcBH1nYC__"